module.exports = __webpack_public_path__ + "static/media/arrowBm.d81ae67a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrowBm.png
// module id = 645
// module chunks = 0 1